import {alpha, Box, styled} from "@mui/material";

const UploadButton = styled(Box)(({theme}) => ({
    width: 50,
    height: 50,
    display: "flex",
    borderRadius: "50%",
    border: "2px solid",
    alignItems: "center",
    justifyContent: "center",
    borderColor: theme.palette.background.paper,
    backgroundColor:
        theme.palette.mode === "light"
            ? theme.palette.secondary[400]
            : alpha(theme.palette.background.paper, 0.9),
}))

export default UploadButton